/**
 * Project chronological dates are YYYY-MM-DD from the API.
 * Parse without Date timezone shifts so public month/year stays correct.
 */

const MONTHS_LONG = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/** Extract YYYY-MM-DD prefix if present. */
export function dateOnly(value: string | null | undefined): string | null {
  if (!value) return null;
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[1]}-${m[2]}-${m[3]}` : null;
}

/** Public project detail: "March 2024" (month + year only). */
export function formatProjectMonthYear(value: string | null | undefined): string | null {
  const ymd = dateOnly(value);
  if (!ymd) return null;
  const [y, m] = ymd.split("-").map(Number);
  if (!y || !m || m < 1 || m > 12) return null;
  return `${MONTHS_LONG[m - 1]} ${y}`;
}

/** Public cards: year only. */
export function formatProjectYear(value: string | null | undefined): number | null {
  const ymd = dateOnly(value);
  if (!ymd) return null;
  const y = Number(ymd.slice(0, 4));
  return Number.isFinite(y) ? y : null;
}

/** Admin list: YYYY-MM-DD as stored. */
export function formatProjectYmd(value: string | null | undefined): string {
  return dateOnly(value) || "—";
}
